<template>
  <div
    class="tooth"
    v-click-outside="onCloseMenu">
    <tooth-popover-menu
      top
      v-bind:value="isShowMenu">
      <template slot="trigger">
        <div class="tooth__body">
          <svg
            v-if="!isDeleted"
            class="tooth-down-3 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 72 183">
            <g v-if="isDiagnosisImplant" id="implant">
              <rect width="25.564" height="13.231" x="23.297" y="109.333" fill="#A8BEC5" stroke="#778F9F" rx="1.397" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.495 126.424H25.663l4.836 55.777h11.904l4.093-55.777Z" />
              <rect width="29.845" height="4.309" x="-.474" y=".474" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" transform="matrix(1 0 0 -1 21.631 127.373)" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23 131.082a1.68 1.68 0 0 1 1.939-1.372l23.52 4.032.168.037a1.68 1.68 0 0 1-.736 3.274l-23.52-4.032A1.68 1.68 0 0 1 23 131.082Zm2.433 5.266.17.02 22.177 3.696a1.68 1.68 0 0 1-.553 3.314l-22.176-3.695-.167-.037a1.681 1.681 0 0 1 .549-3.298Zm.339 6.326.172.02 21.84 3.696a1.68 1.68 0 0 1-.56 3.313l-21.842-3.696-.167-.037a1.68 1.68 0 0 1 .557-3.296Zm-.758 7.729a1.68 1.68 0 0 1 1.928-1.387l20.497 3.36a1.68 1.68 0 1 1-.544 3.316L26.4 152.331a1.679 1.679 0 0 1-1.386-1.928Zm2.141 4.924.171.024 19.152 3.696a1.68 1.68 0 0 1-.636 3.299l-19.153-3.697-.167-.04a1.68 1.68 0 0 1 .634-3.282Zm.671 5.988.17.024 17.472 3.361.168.04a1.681 1.681 0 0 1-.802 3.259l-17.472-3.36-.167-.04a1.681 1.681 0 0 1 .631-3.284Zm.294 6.658.171.02 16.129 2.688a1.68 1.68 0 0 1-.553 3.314l-16.128-2.687-.168-.037a1.681 1.681 0 0 1 .55-3.298Zm.39 6.33.171.025 15.12 3.024.167.041a1.682 1.682 0 0 1-.827 3.253l-15.12-3.024-.166-.041a1.682 1.682 0 0 1 .655-3.278Z" />
            </g>
            <g v-else>
              <path
                d="M23.7556 132.5C23.3397 130.59 24.1306 116.927 23.7557 111.149L47.1341 111.357C46.4409 120.455 43.3322 139.711 42.5002 148.512C41.4603 159.513 40.996 174.367 38.5003 178C36.0045 181.632 31.533 182.047 32.5729 174.99C33.6128 167.932 26.9162 152.352 26.5002 148.512C26.0843 144.672 24.2755 134.887 23.7556 132.5Z"
                v-bind:class="{ selected: isSelected('root_1') }"
                v-bind:fill="partColor['root_1'] || '#FFF'"
                v-on:click="onClick('root_1', $event)"
                v-on:keydown="onClick('root_1', $event)" />
              <path
                d="M40.2692 129.369L40.2834 129.423C40.3823 129.797 40.3702 130.189 40.2525 130.557C36.5493 142.149 35.5953 157.015 34.7237 160.664C34.6447 160.995 34.4349 161.264 34.1596 161.464C33.8859 161.663 33.5194 161.769 33.2737 161.537C33.0444 161.32 32.8321 160.907 32.916 160.122C34.0895 149.147 34.1944 135.842 33.7344 129.522L33.6948 128.852C33.6754 128.525 33.7906 128.204 34.0136 127.963C34.1955 127.767 34.4377 127.637 34.7018 127.594L35.0962 127.529L36.0045 127.545L37.8265 127.787L38.8843 128.068C39.011 128.101 39.1351 128.144 39.2555 128.196C39.756 128.41 40.1299 128.843 40.2692 129.369Z"
                v-bind:class="{ selected: isSelected('central_canal') }"
                v-bind:fill="partColor['central_canal'] || '#FF82BE'"
                v-on:click="onClick('central_canal', $event)"
                v-on:keydown="onClick('central_canal', $event)" />
            </g>
            <path
              v-if="!isDiagnosisImplant || hasCrownOnImplant"
              d="M45.2337 90.533C41.1943 86.3542 37.2326 84.9264 35.3392 84.8916C35.0626 84.9628 34.7913 85.0416 34.5252 85.1273C24.499 88.3575 18.9295 101.87 23.577 111.323C24.0482 112.281 25.9732 116.152 26.6148 117.069C31.4116 123.922 37.7302 123.058 40.2899 121.77C41.7976 120.864 45.3391 116.233 47.2259 111.532C48.7354 107.771 49.6869 102.582 49.4414 100.249C49.3362 98.6818 49.2731 94.7119 45.2337 90.533Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <svg
            v-else-if="isBoneImplant"
            class="tooth-down-3 tooth__parts"
            v-bind:class="{ flip }"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 72 183">
            <g id="implant">
              <rect width="25.564" height="13.231" x="23.297" y="109.333" fill="#A8BEC5" stroke="#778F9F" rx="1.397" />
              <path fill="#778F9F" stroke="#778F9F" stroke-width=".949" d="M46.495 126.424H25.663l4.836 55.777h11.904l4.093-55.777Z" />
              <rect width="29.845" height="4.309" x="-.474" y=".474" fill="#A8BEC5" stroke="#778F9F" stroke-width=".949" rx="1.146" transform="matrix(1 0 0 -1 21.631 127.373)" />
              <path fill="#A8BEC5" stroke="#778F9F" stroke-linecap="round" stroke-width=".949" d="M23 131.082a1.68 1.68 0 0 1 1.939-1.372l23.52 4.032.168.037a1.68 1.68 0 0 1-.736 3.274l-23.52-4.032A1.68 1.68 0 0 1 23 131.082Zm2.433 5.266.17.02 22.177 3.696a1.68 1.68 0 0 1-.553 3.314l-22.176-3.695-.167-.037a1.681 1.681 0 0 1 .549-3.298Zm.339 6.326.172.02 21.84 3.696a1.68 1.68 0 0 1-.56 3.313l-21.842-3.696-.167-.037a1.68 1.68 0 0 1 .557-3.296Zm-.758 7.729a1.68 1.68 0 0 1 1.928-1.387l20.497 3.36a1.68 1.68 0 1 1-.544 3.316L26.4 152.331a1.679 1.679 0 0 1-1.386-1.928Zm2.141 4.924.171.024 19.152 3.696a1.68 1.68 0 0 1-.636 3.299l-19.153-3.697-.167-.04a1.68 1.68 0 0 1 .634-3.282Zm.671 5.988.17.024 17.472 3.361.168.04a1.681 1.681 0 0 1-.802 3.259l-17.472-3.36-.167-.04a1.681 1.681 0 0 1 .631-3.284Zm.294 6.658.171.02 16.129 2.688a1.68 1.68 0 0 1-.553 3.314l-16.128-2.687-.168-.037a1.681 1.681 0 0 1 .55-3.298Zm.39 6.33.171.025 15.12 3.024.167.041a1.682 1.682 0 0 1-.827 3.253l-15.12-3.024-.166-.041a1.682 1.682 0 0 1 .655-3.278Z" />
            </g>
            <path
              v-if="hasCrownOnImplant"
              d="M45.2337 90.533C41.1943 86.3542 37.2326 84.9264 35.3392 84.8916C35.0626 84.9628 34.7913 85.0416 34.5252 85.1273C24.499 88.3575 18.9295 101.87 23.577 111.323C24.0482 112.281 25.9732 116.152 26.6148 117.069C31.4116 123.922 37.7302 123.058 40.2899 121.77C41.7976 120.864 45.3391 116.233 47.2259 111.532C48.7354 107.771 49.6869 102.582 49.4414 100.249C49.3362 98.6818 49.2731 94.7119 45.2337 90.533Z"
              v-bind:class="{ selected: isSelected('crown') }"
              v-bind:fill="partColor['crown'] || '#FFF'"
              v-on:click="onClick('crown', $event)"
              v-on:keydown="onClick('crown', $event)" />
          </svg>
          <button
            class="tooth__body__all-tooth"
            type="button"
            v-on:click="onAllToothClick($event)" />
          <button
            class="tooth__body__gingiva"
            type="button"
            v-bind:class="{ selected: isSelected('gingiva') }"
            v-bind:style="{ 'background-color': partColor['gingiva'] || '#f4ddc1' }"
            v-on:click="onClick('gingiva', $event)" />
          <button
            class="tooth__body__bone"
            type="button"
            v-bind:class="{ selected: isSelected('bone') }"
            v-bind:style="{ 'background-color': partColor['bone'] || '#ffead2' }"
            v-on:click="onClick('bone', $event)" />
        </div>
      </template>
      <form-teeth-formula-diagnoses
        v-bind:class="{ 'disable-component': disabled }"
        v-bind:is-deleted="needDeleted"
        v-bind:part-list="partList"
        v-bind:has-implant="hasImplant"
        v-on:cancel="onCloseMenu"
        v-on:change-diagnoses="onChangeDiagnoses"
        v-on:change-tooth-deleted="onChangeToothDeleted"
        v-on:submit="onSubmit" />
    </tooth-popover-menu>
    <bottom-tooth-surface
      v-bind:surface="surface"
      v-bind:part-selected="partSelected"
      v-bind:selected-parts="selectedParts"
      v-bind:flip="flip"
      v-on:select="onClick" />
    <div class="tooth__number">{{ tooth.number }}</div>
  </div>
</template>
<script>
import toothMixin from '@/mixins/toothMixin';
import ToothPopoverMenu from '../ToothPopoverMenu.vue';
import FormTeethFormulaDiagnoses from '../FormTeethFormulaDiagnoses.vue';
import BottomToothSurface from '../BottomToothSurface.vue';

export default {
  components: {
    ToothPopoverMenu,
    FormTeethFormulaDiagnoses,
    BottomToothSurface,
  },
  mixins: [toothMixin],
  name: 'ToothDown3',
};
</script>

<style scoped>
.tooth {
  flex-direction: column-reverse;
}
.tooth__body {
  grid-template-rows: 30px 25px 66px;
}
.tooth__parts {
  top: auto;
  bottom: 17.28px;
}
</style>
